import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useInvoice } from '../context/InvoiceContext';
import { useConfirm } from '../context/ConfirmContext';
import InvoiceEditModal from './InvoiceEditModal';
import { formatCurrency } from '../utils/formatCurrency';

const InvoiceCard = ({ invoice, onView }) => {
  const { canEdit, canDelete, deleteInvoice, downloadInvoice } = useInvoice();
  const confirm = useConfirm();
  const [showEditModal, setShowEditModal] = useState(false);

  const handleDelete = async () => {
    const ok = await confirm('Are you sure you want to delete this invoice? This cannot be undone.', {
      title: 'Delete Invoice',
      confirmLabel: 'Delete',
      danger: true
    });
    if (ok) await deleteInvoice(invoice.id);
  };

  const handleDownload = () => {
    downloadInvoice(invoice.id, invoice.originalName);
  };

  return (
    <>
      <tr
        className="todo-row"
        onClick={() => onView && onView(invoice)}
        style={{ borderBottom: '1px solid var(--color-gray-200)', cursor: 'pointer' }}
      >
        <td data-label="Date" style={{ padding: 'var(--spacing-sm)', fontSize: 'var(--font-size-sm)' }}>
          {new Date(invoice.invoiceDate).toLocaleDateString('en-GB')}
        </td>
        <td data-label="Vendor" style={{ padding: 'var(--spacing-sm)', fontSize: 'var(--font-size-sm)', fontWeight: 'var(--font-weight-medium)', maxWidth: '180px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {invoice.vendorName || 'No Vendor'}
        </td>
        <td data-label="Amount" style={{ padding: 'var(--spacing-sm)', fontSize: 'var(--font-size-sm)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-primary)', textAlign: 'right' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--spacing-xs)' }}>
            {formatCurrency(invoice.amount || 0)}
            {invoice.gstIncluded && (
              <span style={{
                fontSize: '10px',
                padding: '1px 4px',
                backgroundColor: 'var(--color-gray-100)',
                color: 'var(--color-secondary)',
                borderRadius: 'var(--radius-sm)',
                fontWeight: 'var(--font-weight-normal)',
                lineHeight: '1.4'
              }}>GST</span>
            )}
          </span>
        </td>
        <td data-label="Notes" style={{ padding: 'var(--spacing-sm)', fontSize: 'var(--font-size-sm)', color: 'var(--color-secondary)', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {invoice.notes || '-'}
        </td>
        <td data-label="By" style={{ padding: 'var(--spacing-sm)', fontSize: 'var(--font-size-sm)', color: 'var(--color-secondary)', whiteSpace: 'nowrap' }}>
          {invoice.uploader?.firstName || '-'}
        </td>
        <td style={{ padding: 'var(--spacing-sm)', textAlign: 'right' }}>
          <div className="flex gap-md" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
            {invoice.filename && (
              <button onClick={e => { e.stopPropagation(); onView && onView(invoice); }} className="btn btn-warning btn-sm" title="View">
                View
              </button>
            )}
            {invoice.filename && (
              <button onClick={e => { e.stopPropagation(); handleDownload(); }} className="btn btn-outline btn-sm" title="Download">
                Download
              </button>
            )}
            {canEdit(invoice) && (
              <button onClick={e => { e.stopPropagation(); setShowEditModal(true); }} className="btn btn-secondary btn-sm" title="Edit">
                Edit
              </button>
            )}
            {canDelete(invoice) && (
              <button onClick={e => { e.stopPropagation(); handleDelete(); }} className="btn btn-error btn-sm" title="Delete">
                Delete
              </button>
            )}
          </div>
        </td>
      </tr>

      {showEditModal && createPortal(
        <InvoiceEditModal
          invoice={invoice}
          onClose={() => setShowEditModal(false)}
        />,
        document.body
      )}
    </>
  );
};

export default InvoiceCard;
